import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import 'rxjs/add/operator/map';

import { Globals } from '../providers/globals';
import { HttpHelper } from '../helpers/httpHelper';
import { Storage } from '@ionic/storage';

/*
  Generated class for the ConsumerRewardHandlerProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular DI.
*/
@Injectable()
export class BusinessUserInvoiceProvider {
  url: any;
  token: any;
  categoryId: any = 0;
  rewardId: any = 0; 

  rewards: any=[];
  selectedReward: any={};

  constructor(
  		  public http: Http,
		    public globals: Globals,
      	public storage: Storage,
      	public httpHelper: HttpHelper) {    
  }
  
  getById(params){  
    return new Promise( (resolve, reject) => {
        this.url = this.globals.dataUrl + 'businessUserInvoice/userId/' + params.id +
                                      '/page/' + params.page + 
                                      '/size/' + params.size;

      this.storage.get('loginData').then((loginData) => {
          this.http.get(
              this.url,
              this.httpHelper.configOptionsWithToken(loginData.access_token)
          )
          .map(res => res.json())
          .subscribe(
          data => {
            resolve(data);
          },
          err => {reject(err)}
           );  
      });
    });      
    }

  getUsers(params){  
    this.url = this.globals.dataUrl + 'businessUserInvoice/whiskey/' + this.globals.whiskeyId + '/search' +                                   
                                      '/page/' + params.page  +
                                      '/size/' + params.size  +
                                      '?term=' + params.term;

    this.storage.get('loginData').then((loginData) => {
      this.token = loginData.access_token

      this.http.get(
        this.url,
        this.httpHelper.configOptionsWithToken(loginData.access_token)
      )
      .map(res => res.json())
      .subscribe(res => {
          if(params.cb) params.cb(res.Data);
      });   
    })
  }     
}



// WEBPACK FOOTER //
// ./src/providers/business-user-invoice-handler.ts